import React from "react";
import {
  ArrayField,
  Button,
  ChipField,
  Labeled,
  ShowProps,
  SingleFieldList,
  TextField,
} from "react-admin";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { GridinRowsWithSpace } from "utils/style";
import EditIcon from "@material-ui/icons/Edit";
import StatusField from "../../components/StatusField";

const useStyles = makeStyles({
  summaryButton: {
    position: "relative",
    top: 20,
    padding: "8px 16px",
  },
});

const Summary = (props: ShowProps) => {
  const classes = useStyles();

  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12} style={GridinRowsWithSpace}>
          <Typography variant="h6">User Detail</Typography>
          <Button
            className={classes.summaryButton}
            onClick={() => props.history.push(`/users/${props.id}`)}
            label="Edit"
          >
            <EditIcon />
          </Button>
        </Grid>

        <Grid item xs={6}>
          <Labeled source="Email">
            <TextField source="email" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={2}>
          <Labeled source="Roles">
            <ArrayField source="roles">
              <SingleFieldList linkType={false}>
                <ChipField source="name" />
              </SingleFieldList>
            </ArrayField>
          </Labeled>
        </Grid>
        <Grid item xs={2}>
          <Labeled source="Status">
            <StatusField label="Status" source="admin.status" />
          </Labeled>
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={2}>
          <Labeled source="Schools">
            <ArrayField source="admin.schools">
              <SingleFieldList linkType={false}>
                <ChipField source="name" />
              </SingleFieldList>
            </ArrayField>
          </Labeled>
        </Grid>
        <Grid item xs={10}></Grid>
      </SanitizedGrid>
    </>
  );
};

export default Summary;
